import React from "react";
import "../style/ModalDelete.css";

function BidderModal({ show, bidder, onClose, auction }) {
  if (!show || !bidder) {
    return null;
  }

  const { user, amount } = bidder;

  const solicitarCompra = async () => {
    const formatted = user?.telefono.replace(/\D/g, ""); 
    const message = ``
    const url = 'https://wa.me/' + formatted + '?text=' + encodeURIComponent(message)
    await window.open(url, '_blank')
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-button-left" onClick={onClose}>X</button>
        <h2>Información del Comprador</h2>
        <p><strong>Nombre:</strong> {user?.nombre || "Anonimo"}</p>
        <p><strong>Teléfono:</strong> {user?.telefono || "No proporcionado"}</p>
        <p><strong>Oferta:</strong> ${amount}</p>
        <button className="red-button" onClick={() => solicitarCompra()}>WhatsApp</button>
      </div>
    </div>
  );
}

export default BidderModal;
